export const clearedFilters = {
    ralnr: '',
    raltype: '',
    poedernr: '',
    poedernr2: '',
    poedernr3: '',
};
